import React, { useEffect } from 'react';
import { NavBarTwo } from '../components/Header';
import { Footer } from '../components/Footer';
import { ImgCard, ImgCardLg } from '../components/Component';
import Aos from "aos";
import "aos/dist/aos.css";


export function About()
{

    useEffect( ()=> Aos.init({ duration: 2000 }) , [])

    return(

        <div className="container-fluid">

           <title> Apropos | Samadoc </title>
           <meta name="author" content="Xelkoom-ai" />
           <meta name="keywords" content="document, gestion de fichier, université Sénégalaise , document académique " />
           <meta name="description" content="Découvrez Samadoc, une solution innovante qui optimise l’accès aux ressources académiques." />

            <div className="row"> 
                
                {/* *************************************************************** */}
                <div className="col-lg-12 bg-green-dark sticky-top">  <NavBarTwo target={'about'} />  </div>

                {/* *************************************************************** */}
                <div className="col-lg-12 py-5 bg-white"> 
                    <div className="row d-flex justify-content-center py-5 mt-4"> 
                        <div className="col-lg-11"> 
                            <div className="row"> 
                                <div className="col-lg-5"> 
                                    <div className="border d-flex align-items-center py-5 mb-4 bg-light" data-aos="fade-right"> 
                                        <img src="../img/img-groupe-8.png" className="img-fluid"  alt="" /> 
                                    </div>
                                </div>
                                {/* ------------------------------------------- */}
                                <div className="col-lg-7 px-4"> 
                                    <div className="row mb-4" data-aos="fade-up">
                                        <span className="h2 text-muted border py-2 px-4 bg-light"> Apropos de Samadoc </span>
                                        {/* <h3 className="h1 color-orange"> Apros </h3> */}
                                    </div>
                                    <div className="row" data-aos="fade-up">
                                        <div className="col-md-6 mb-4">  
                                            <ImgCardLg img={'../img/icons8-outils-administratifs-64.png'} text={"Téléverser des fichiers (PDF, DOCX, PPT, MP4, etc.) et les organiser dans les dossiers correspondants."} />
                                        </div>
                                        <div className="col-md-6 mb-4">  
                                            <ImgCardLg img={'../img/icons8-outils-administratifs-64.png'} text={"Fonctionnalité de prévisualisation pour consulter les fichiers sans les télécharger."} />
                                        </div>
                                        <div className="col-md-6 mb-4">  
                                            <ImgCardLg img={'../img/icons8-outils-administratifs-64.png'} text={"Les utilisateurs peuvent inviter d'autres personnes à accéder à leur répertoire."} />
                                        </div>
                                        <div className="col-md-6 mb-4">  
                                            <ImgCardLg img={'../img/icons8-outils-administratifs-64.png'} text={"Options de gestion des autorisations: lecture seule ou modification des fichiers."} />
                                        </div>
                                        <div className="col-md-6 mb-4">  
                                            <ImgCardLg img={'../img/icons8-outils-administratifs-64.png'} text={'Système de sauvegarde automatique pour éviter toute perte de données.'} />
                                        </div>
                                        <div className="col-md-6 mb-4">  
                                            <ImgCardLg img={'../img/icons8-outils-administratifs-64.png'} text={"Une application à la fois mobile, web et  avec une UX bien optimisée. "} />
                                        </div>
                                    </div>
                                </div>
                                {/* ------------------------------------------- */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* *************************************************************** */}
                <div className="col-lg-12 py-5 bg-light border-bottom border-top"> 
                    <div className="row d-flex justify-content-center py-5"> 
                        <div className="col-lg-10 d-flex justify-content-center mb-5" data-aos="fade-up"> 
                            <h3 className="h3 text-muted mb-4"> Les extensions de fichiers supportés par notre plateforme </h3>
                        </div>
                        <div className="col-lg-10"> 
                            {/* ------------------------------------------- */}
                            <div className="row" data-aos="fade-up"> 

                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-word.png'} title={'fichier word'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-pdf.png'} title={'fichier pdf'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-access.png'} title={'fichier access'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-excel.png'} title={'fichier excel'} /></div>

                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-word.png'} title={'fichier word'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-pdf.png'} title={'fichier pdf'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-access.png'} title={'fichier access'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-excel.png'} title={'fichier excel'} /></div>

                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-word.png'} title={'fichier word'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-pdf.png'} title={'fichier pdf'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-access.png'} title={'fichier access'} /></div>
                                <div className="col-lg-3 col-md-6 mb-4">  <ImgCard img={'../img/img-excel.png'} title={'fichier excel'} /></div>

                            </div>    
                        </div>
                    </div>
                </div>

                {/* *************************************************************** */}
                

                <div className="col-lg-12 py-5 bg-white border-bottom"> 
                    <div className="row d-flex justify-content-center py-4"> 
                        <div className="col-lg-11"> 
                            {/* ------------------------------------------- */}
                            <div className="row d-flex justify-content-center"> 
                                <div className="col-md-5 px-4 mb-4"> 
                                    <div className="d-flex flex-column align-items-center">
                                        <h2 className="h1 text-muted mb-1 text-center mb-2">  La plateforme Samadoc </h2>   
                                        <p className="lead text-muted text-center">  integre des fonctionnalités innovantes et performantes pour la gestion et le paratge de document. </p>  
                                    </div>
                                </div>
                            </div>
                            {/* ------------------------------------------- */}
                            <div className="row" data-aos="fade-up"> 
                                {/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                                <div className="col-md-6"> 
                                    <div className="p-4">
                                        <div className="row bg-light rounded-3 p-4 shadow-sm">
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <div className="d-flex flex-column">
                                                    <h4 className="h4 color-orange"> Interfaces optimisés </h4>
                                                    <p className="font-md text-muted"> Notre plateforme de partage de documents académiques est conçue pour offrir une expérience fluide et agréable aux étudiants, professeurs et autres utilisateurs. </p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 d-flex justify-content-end">
                                                <div className="d-flex">
                                                    <img src="../img/psd-3.png" className="img-fluid max-h-180"  alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                                <div className="col-md-6"> 
                                    <div className="p-4">
                                    <div className="row bg-light rounded-3 p-4 shadow-sm">
                                        <div className="col-lg-8 d-flex align-items-center">
                                            <div className="d-flex flex-column ">
                                                <h4 className="h4 color-orange"> Simple d'utilisation </h4>
                                                <p className="font-md text-muted"> Samadoc simplifie l’organisation, le partage et la collaboration autour des documents académiques, offrant ainsi un outil essentiel pour l'apprentissage. </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 d-flex justify-content-end">
                                            <div className="d-flex">
                                                <img src="../img/psd-3.png" className="img-fluid max-h-180"  alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                {/* ------------------------------------------- */}

                            </div>
                        </div>
                    </div>
                </div>

                {/* *************************************************************** */}
                <div className="col-lg-12 bg-green-dark">  <Footer />  </div>
            
            </div>
        </div>
                                
    )
}